// extracted by mini-css-extract-plugin
module.exports = {"single-nav-menu":"SingleNavMenu_single-nav-menu__3hzW3","active":"SingleNavMenu_active__1UswE"};